
<div class="context-item" (click)="onAction($event)">

  <fa-icon *ngIf="icon !== null" [icon]="icon"></fa-icon>
  <span *ngIf="icon === null"></span>

  <span><ng-content></ng-content></span>

</div>
